import { Box, Typography } from '@mui/material';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '@Components/Modal';
import SMTPSettingsNotVerifiedModalProps from '@Components/SMTPSettingsNotVerifiedModal/SMTPSettingsNotVerifiedModal.types';

const SMTPSettingsNotVerifiedModal: FunctionComponent<SMTPSettingsNotVerifiedModalProps> =
  (props: SMTPSettingsNotVerifiedModalProps): JSX.Element => {
    const { t } = useTranslation();

    const { isModalOpen, setIsModalOpen, onClick } = props;

    const handleModalClose = () => {
      setIsModalOpen(false);
    };

    return (
      <Modal
        open={isModalOpen}
        onClose={handleModalClose}
        headerText={t('SMTP.verificationModal.headerText')}
      >
        <Box
          position="relative"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: '24px',
            marginBottom: '74px',
          }}
        >
          <Typography
            component="h2"
            fontWeight="bold"
            fontSize="24px"
            lineHeight="33px"
            color="#767676"
          >
            {t('SMTP.verificationModal.SMTP Settings are not verified')}
          </Typography>
          <Typography
            fontWeight="400"
            sx={{ width: '432px', textAlign: 'center', marginBottom: '16px' }}
          >
            {t(
              'SMTP.verificationModal.Please check your inbox and confirm your SMTP settings'
            )}
          </Typography>
          <Typography>
            {t('SMTP.verificationModal.Haven`t received email')}{' '}
            <Typography
              component="span"
              sx={{ color: '#0045B9', cursor: 'pointer' }}
              onClick={onClick}
            >
              {t('SMTP.verificationModal.Send again')}
            </Typography>
          </Typography>
        </Box>
      </Modal>
    );
  };

export default SMTPSettingsNotVerifiedModal;
